module.exports = __webpack_public_path__ + "static/media/golf.fd312ae0.png";